import angular from 'angular';
import {
  ssDialogService,
  loaderService,
  reportsDataService,
} from 'app/services';
import {
  alerts,
  actionIcon
} from 'app/components/global';
import controller from './edit-report-status-dialog.controller';
import template from './edit-report-status-dialog.html';


export class dialogService {
  getOptions($event, { reportInstance, isNavantaUser, users }) {
    return {
      controller,
      controllerAs: 'editReportStatusDialogVM',
      locals: {
        reportInstance,
        isNavantaUser,
        users
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.reports.editReportStatusDialog', [
  ssDialogService,
  loaderService,
  reportsDataService,
  alerts,
  actionIcon
])
  .service('editReportStatusDialog', dialogService)
  .name;

console.log('app.components.reports.editReportStatusDialog created');
